export const ITEM_TIPO_PRODUCTO = 'Producto';
export const ITEM_TIPO_MANO_DE_OBRA = 'Mano De Obra';

// VEC-3231: clasificación única "es mano de obra" por tipo de ítem (case-insensitive). Centraliza el
// predicado replicado en la carga/precarga de presupuesto detallado. El guard de trabajaConManoDeObra
// queda en el caller (con el flag off la MO va por tareas y todo ítem es repuesto).
export function esManoDeObra(tipo) {
    return !!tipo && tipo.toLowerCase() === ITEM_TIPO_MANO_DE_OBRA.toLowerCase();
}
